<template>
  <modal :showModal="showModal"  @clickMask="$emit('close')">
    <v-container slot="body">
      <label>{{inputMsg}}</label>
      <v-file-input :accept="accept" @change="setFile" :prepend-icon="mdiPaperclip"></v-file-input>
    </v-container>
    <v-container slot="footer" style="display: inline;">
      <div style="float: right; height: max-content;">
        <v-btn @click="$emit('close')">Cancel</v-btn>
      </div>
    </v-container>
  </modal>
</template>

<script>

import Modal from "./Modal"
import {mdiPaperclip} from "@/svgIcons"

/** \brief  The modal window to use to open file */
export default {
  components: {
    Modal,
  },
  props: {
    /** \brief  Whether the modal window should be opened or not */
    showModal: { type: Boolean },
    /** \brief  The message to display to give users hints on what we expect from him/her */
    inputMsg: { type: String },
    /** \brief  The MIMETYPE files to accept */
    accept: { type: String },
  },
  data(){
    return {
      file: null,
      mdiPaperclip: mdiPaperclip,
    }
  },
  mounted() {
    document.addEventListener('keydown', this.keydownHandler);
  },
  destroyed() {
    document.removeEventListener('keydown', this.keydownHandler);
  },
  methods: {
    /** \brief Automatically called when a user has selected a file 
    * \param file the File the user has selected. Fire the 'done' event */
    setFile(file) {
      this.file = file;
      this.$emit('done', this.file);
    },
    /** \brief  Listen for the "escape" key to close the modal window
    * \param event the keydown event*/
    keydownHandler(event)  {
      if(event.keyCode == 27 && this.showModal) // escape
        this.$emit('close');
    },
  },
};

</script>
<style scoped>
.file-select > .select-button {
  padding: 5px;
  color: white;
  background-color: #2EA169;
  border-radius: .1rem;
  text-align: center;
  font-weight: bold;
  float: left;
}

/* Don't forget to hide the original file input! */
.file-select > input[type="file"] {
  display: none;
}
</style>
